import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { get, isEmpty } from 'lodash';
import { hooks } from '../../../config/api';
import replaceAndCapitalizeString from '../../utils/replaceAndCapitalizeString';
var useFormSubmissions = function useFormSubmissions(_ref) {
  var contextType = _ref.contextType,
    context = _ref.context,
    size = _ref.size,
    page = _ref.page,
    providerId = _ref.providerId,
    formTypeFilter = _ref.formTypeFilter,
    formFilter = _ref.formFilter;
  var filters = _objectSpread(_objectSpread({
    'form.form_usages.provider': providerId
  }, formTypeFilter ? {
    'form.form_usages.usage_type': formTypeFilter
  } : []), {}, {
    'context.type': contextType,
    context: context
  }, formFilter ? {
    form: formFilter
  } : []);
  var queryOptions = {
    api: 'coreApi',
    page: {
      size: size,
      number: page
    },
    queryConfig: {
      refetchInterval: false,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      enabled: !isEmpty(providerId) && !isEmpty(context)
    }
  };
  var formSubmissionQuery = hooks.useFind('form_submission', filters, queryOptions);
  var formSubmissions = get(formSubmissionQuery, 'data.data.data', [], queryOptions);
  var paging = get(formSubmissionQuery, 'data.data.paging', {}, queryOptions);
  var sqProvider = hooks.usePopulate('provider', 'provider', formSubmissions, queryOptions);
  var submitterQuery = hooks.usePopulate('submitter', 'employee', formSubmissions, queryOptions);
  var fQuery = hooks.usePopulate('form', 'form', formSubmissions, {
    queryParams: {
      'form_usages.provider': providerId
    }
  }, queryOptions);
  var formIds = _mapInstanceProperty(formSubmissions).call(formSubmissions, function (submission) {
    return submission.form.id;
  });
  var formUsagesQuery = hooks.useFind('form_usages', {
    form: formIds.join(','),
    provider: providerId
  }, {
    queryConfig: {
      refetchInterval: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      enabled: !isEmpty(providerId) && !isEmpty(context)
    }
  });
  var formUsages = get(formUsagesQuery, 'data.data.data', [], queryOptions);
  var isFetching = hooks.usePopulateMemo(formSubmissionQuery.data, [formSubmissionQuery, submitterQuery, fQuery, sqProvider]);
  formSubmissions.forEach(function (submission) {
    submission.usage_types = [];
    _mapInstanceProperty(formUsages).call(formUsages, function (usage) {
      if (usage.form.id === submission.form.id) {
        var _context;
        var formattedUsageType = replaceAndCapitalizeString(usage.usage_type, '_');
        if (!_includesInstanceProperty(_context = submission.usage_types).call(_context, formattedUsageType)) {
          submission.usage_types.push(formattedUsageType);
        }
      }
    });
  });
  return {
    paging: paging,
    formSubmissions: formSubmissions,
    isFetching: isFetching
  };
};
export default useFormSubmissions;
//# sourceMappingURL=useFormSubmissions.js.map